import { useMemo } from "react"

import map from "lodash/map"

const useContentfulEdges = ({ edges }) =>
  useMemo(() => map(edges, ({ node }) => node), [edges])

export default useContentfulEdges
